import React from "react";

interface DenomRowProps {
  denom: number;
  count: number;
  onCountChange: (denom: number, val: number) => void;
}

export const DenomRow: React.FC<DenomRowProps> = ({
  denom,
  count,
  onCountChange,
}) => {
  return (
    <div
      className="grid items-center gap-1.5 px-2 py-[5px] border-b border-gray-50 last:border-none hover:bg-gray-50/60"
      style={{ gridTemplateColumns: "1fr auto auto" }}
    >
      <span className="text-[11px] font-medium text-gray-800">
        LKR {denom.toLocaleString()}
      </span>

      <div className="flex items-center border border-gray-200 rounded-md overflow-hidden">
        <button
          onClick={() => onCountChange(denom, count - 1)}
          className="w-5 h-[22px] flex items-center justify-center bg-gray-50 hover:bg-gray-100 text-gray-500 border-none cursor-pointer text-sm leading-none"
        >
          −
        </button>
        <input
          type="number"
          value={count || ""}
          onChange={(e) => onCountChange(denom, parseInt(e.target.value) || 0)}
          placeholder="0"
          className="w-7 h-[22px] text-center border-x border-gray-200 text-[11px] font-semibold text-gray-900 bg-transparent outline-none"
        />
        <button
          onClick={() => onCountChange(denom, count + 1)}
          className="w-5 h-[22px] flex items-center justify-center bg-gray-50 hover:bg-gray-100 text-gray-500 border-none cursor-pointer text-sm leading-none"
        >
          +
        </button>
      </div>

      <span className="text-[10px] text-gray-400 w-12 text-right">
        {count > 0 ? `LKR ${(denom * count).toLocaleString()}` : ""}
      </span>
    </div>
  );
};
